/**
 * Thin wrapper around @capacitor/local-notifications.
 * Falls back to a no-op stub when running in the browser (dev/web preview)
 * or before the package is installed. The real Capacitor plugin is used on
 * native iOS/Android builds after `npm install @capacitor/local-notifications`.
 */

let _LN = null;

function noopPlugin() {
  return {
    requestPermissions: async () => ({ display: "denied" }),
    schedule: async () => {},
    cancel: async () => {},
    getPending: async () => ({ notifications: [] }),
  };
}

function wrapCapacitorPlugin(plugin) {
  // Capacitor plugin proxies can expose a trapped `.then` property on web.
  // Returning the proxy directly from an async function makes Promise
  // resolution touch that property and throw "LocalNotifications.then()".
  return {
    requestPermissions: (...args) => plugin.requestPermissions(...args),
    schedule: (...args) => plugin.schedule(...args),
    cancel: (...args) => plugin.cancel(...args),
    getPending: (...args) => plugin.getPending(...args),
  };
}

async function getPlugin() {
  if (_LN) return _LN;
  const platform = typeof window !== "undefined" ? window.Capacitor?.getPlatform?.() : undefined;
  const native = platform === "ios" || platform === "android";
  if (!native) {
    _LN = noopPlugin();
    return _LN;
  }
  try {
    // Dynamic import — only resolves on native builds where the package is installed
    const mod = await import("@capacitor/local-notifications");
    _LN = wrapCapacitorPlugin(mod.LocalNotifications);
  } catch {
    // Not available (web preview or package not yet installed)
    _LN = noopPlugin();
  }
  return _LN;
}

export { getPlugin as getLocalNotifications };
